import { Button, message } from 'antd';
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { objectToFormData } from "../../utils";
import TableWrap from "../Common/Table/Table";
// import moment from "moment";


import { userReportLinkTrip, userTrips } from "../../actions/trips";
import "./report.css";

message.config({
  maxCount: 3,
});

const LinkTrips = (props) => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = React.useState([]);
  const userTripsResponse = useSelector(state => state.trips.userTrips || {});

  React.useEffect(() => {
    dispatch(userTrips({ added_to_report: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: { response: { trips = [] } = {}, total_records = 0 } = {} } = userTripsResponse;


  const columns = [
    {
      title: "Trip ID",
      dataIndex: "trip_number",
      key: "trip_number",
    },
    {
      title: "Trip name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
    },
    // {
    //   title: "Purpose",
    //   dataIndex: "business_purpose",
    //   key: "business_purpose",
    //   // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    // },

  ];

  const rowSelection = {
    selectedRowKeys: selectedData,
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows, selectedData);
      setSelectedData(selectedRowKeys);
    }
  };

  const userReportLinkTripResponse = useSelector(
    (state) => state.trips.userReportLinkTrips || {}
  );

  React.useEffect(() => {
    const { data: { status = false } = {} } =
      userReportLinkTripResponse;
    if (status) {
      dispatch(userTrips({ added_to_report: false }));
      handleClearList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkTripResponse]);

  const handleClearList = () => {
    setSelectedData([]);
  }

  const handleAddExp = () => {
    const payload = {};
    payload.trips = selectedData;
    payload.report_id = props.report_id;
    dispatch(userReportLinkTrip(objectToFormData({ ...payload })));
    setSelectedData([]);
  }

  return (
    <div className="advances-table">
      {selectedData.length ?
        <>
          <Button type="default" ghost className="approve-add-btn mb1" onClick={() => handleClearList()}>
            Clear Selection
          </Button>
          <Button
            onClick={() => handleAddExp()}
            className="floatRight ml1 primaryButton"
          >
            Add {selectedData.length > 1 ?selectedData.length : ""} Trips
          </Button></> : null}
      <TableWrap
        rowKey="id"
        columns={columns}
        data={trips}
        className="tableStyled"
        pagination={{
          total: total_records,
          onChange: (pagee) => {
            dispatch(userTrips(({ added_to_report: false, page: pagee })));
          },
        }}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default LinkTrips;
